var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessory4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 40,
    viewBox: "0 0 109 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_6875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 4.38095C3.54808 4.38095 4.57143 3.40024 4.57143 2.19048C4.57143 0.980709 3.54808 0 2.28571 0C1.02335 0 0 0.980709 0 2.19048C0 3.40024 1.02335 4.38095 2.28571 4.38095Z",
    fill: "#297A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85707 10.7048C9.3818 10.7048 11.4285 8.73484 11.4285 6.30479C11.4285 3.87473 9.3818 1.90479 6.85707 1.90479C4.33234 1.90479 2.28564 3.87473 2.28564 6.30479C2.28564 8.73484 4.33234 10.7048 6.85707 10.7048Z",
    fill: "#2E8651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7141 17.2952C17.5012 17.2952 20.5712 14.3446 20.5712 10.7047C20.5712 7.06491 17.5012 4.11426 13.7141 4.11426C9.92698 4.11426 6.85693 7.06491 6.85693 10.7047C6.85693 14.3446 9.92698 17.2952 13.7141 17.2952Z",
    fill: "#359A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8572 23.8856C27.9067 23.8856 32.0001 19.9458 32.0001 15.0856C32.0001 10.2255 27.9067 6.28564 22.8572 6.28564C17.8078 6.28564 13.7144 10.2255 13.7144 15.0856C13.7144 19.9458 17.8078 23.8856 22.8572 23.8856Z",
    fill: "#3AA364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5716 32.3809C42.8835 32.3809 48.0002 27.4603 48.0002 21.3904C48.0002 15.3205 42.8835 10.3999 36.5716 10.3999C30.2598 10.3999 25.1431 15.3205 25.1431 21.3904C25.1431 27.4603 30.2598 32.3809 36.5716 32.3809Z",
    fill: "#40B26E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.686 4.38095C107.948 4.38095 108.971 3.40024 108.971 2.19048C108.971 0.980709 107.948 0 106.686 0C105.423 0 104.4 0.980709 104.4 2.19048C104.4 3.40024 105.423 4.38095 106.686 4.38095Z",
    fill: "#297A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.114 10.7048C104.639 10.7048 106.686 8.73484 106.686 6.30479C106.686 3.87473 104.639 1.90479 102.114 1.90479C99.5897 1.90479 97.543 3.87473 97.543 6.30479C97.543 8.73484 99.5897 10.7048 102.114 10.7048Z",
    fill: "#2E8651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.257 17.2952C99.0441 17.2952 102.114 14.3446 102.114 10.7047C102.114 7.06491 99.0441 4.11426 95.257 4.11426C91.4699 4.11426 88.3999 7.06491 88.3999 10.7047C88.3999 14.3446 91.4699 17.2952 95.257 17.2952Z",
    fill: "#359A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.114 23.8856C91.1635 23.8856 95.2569 19.9458 95.2569 15.0856C95.2569 10.2255 91.1635 6.28564 86.114 6.28564C81.0646 6.28564 76.9712 10.2255 76.9712 15.0856C76.9712 19.9458 81.0646 23.8856 86.114 23.8856Z",
    fill: "#3AA364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3998 32.3809C78.7116 32.3809 83.8283 27.4603 83.8283 21.3904C83.8283 15.3205 78.7116 10.3999 72.3998 10.3999C66.0879 10.3999 60.9712 15.3205 60.9712 21.3904C60.9712 27.4603 66.0879 32.3809 72.3998 32.3809Z",
    fill: "#40B26E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4858 40.0002C63.1442 40.0002 69.3525 34.0306 69.3525 26.6668C69.3525 19.303 63.1442 13.3335 55.4858 13.3335C47.8275 13.3335 41.6191 19.303 41.6191 26.6668C41.6191 34.0306 47.8275 40.0002 55.4858 40.0002Z",
    fill: "#4CCF80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_6875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.971,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory4);
export default __webpack_public_path__ + "static/media/accessory-4.eecf8f46a2eec4bf7fa61573d4e7bf85.svg";
export { ForwardRef as ReactComponent };